import React from "react";
import _pubBab5A68F, {Preview as _pubBab5A68F_Preview} from "../../../../../design-system/src/utils.pc";
import _pub2Dbb4493 from "../../../../../design-system/src/Button.pc";
import "./index.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var Tooltip = React.memo(React.forwardRef(function Tooltip(props, ref) {
  return React.createElement("div", {
    "className": "_3f5ba5ce _2f88780d _pub-2f88780d" + (props["class"] ? " " + props["class"] : "") + " " + " " + (props["className"] ? " " + props["className"] : "") + (props["top"] ? " " + "_2f88780d_top _pub-2f88780d_top top" : "") + (props["visible"] ? " " + "_2f88780d_visible _pub-2f88780d_visible visible" : "") + (props["bottom"] ? " " + "_2f88780d_bottom _pub-2f88780d_bottom bottom" : ""),
    "ref": ref,
  }, 
    props["children"]
  )
}));
export { Tooltip };


